import { render, staticRenderFns } from "./VersionInfo.vue?vue&type=template&id=6d88c473&scoped=true"
import script from "./VersionInfo.vue?vue&type=script&lang=js"
export * from "./VersionInfo.vue?vue&type=script&lang=js"
import style0 from "./VersionInfo.vue?vue&type=style&index=0&id=6d88c473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88c473",
  null
  
)

export default component.exports